import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';

import { NotificationService } from '../../../notifications/notification.service';
import { PublicHealthRecordTypeService } from '../public-health-record-type.service';
import {
    LoadPublicHealthRecordTypesFail, LoadPublicHealthRecordTypesSuccess,
    PublicHealthRecordTypeActionTypes
} from './public-health-record-type.actions';

@Injectable()
export class PublicHealthRecordTypeEffects {


  constructor(
    private service: PublicHealthRecordTypeService,
    private actions$: Actions,
    private notificationService: NotificationService,
    private translateService: TranslateService) {
  }


  @Effect({ dispatch: false })
  genericFail$ = this.actions$.pipe(
    ofType<Action & { payload: string }>(
      PublicHealthRecordTypeActionTypes.LoadPublicHealthRecordTypesFail,
    ),
    tap(action => this.notificationService.error(action.payload))
  );


  @Effect()
  loadUsers$ = this.actions$.pipe(
    ofType(PublicHealthRecordTypeActionTypes.LoadPublicHealthRecordTypes),
    mergeMap(_ =>
      this.service.getAll().pipe(
        map(items =>
          {
            items.forEach(item => item.name = this.translateService.instant(item.name));
            return  new LoadPublicHealthRecordTypesSuccess(items);
          }),
        catchError(err => of(new LoadPublicHealthRecordTypesFail(err)))
      )
    )
  );

}
